// src/components/SuperDebugger.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// 假設你有用 Context，請 import (如果沒有可以拿掉這行)
// import { useAuth } from '../../context/AuthContext'; 

const SuperDebugger = ({ merchantSlug }) => {
  const [isOpen, setIsOpen] = useState(false); // 預設縮小
  const [storageData, setStorageData] = useState({});
  const location = useLocation();
  
  // 如果你有 AuthContext，這裡拿 User 資料
  // const { user, token } = useAuth(); 
  // 暫時我模擬一個 user 變數，你換成真的 context
  const user = "從 Context 獲取的 User"; 

  // 定時 refresh storage 資料 (因為 storage 變動不會觸發 re-render)
  useEffect(() => {
    const updateData = () => {
      setStorageData({
        localStorage: { ...localStorage },
        sessionStorage: { ...sessionStorage },
      });
    };

    updateData(); // 初始執行
    const interval = setInterval(updateData, 1000); // 每秒更新一次

    return () => clearInterval(interval);
  }, []);

  if (process.env.NODE_ENV === 'production') return null; // 上線時自動隱藏

  return (
    <div style={styles.container}>
      <button onClick={() => setIsOpen(!isOpen)} style={styles.button}>
        {isOpen ? '🔽 Hide Debug' : '🐞 Debug'}
      </button>

      {isOpen && (
        <div style={styles.panel}>
          <h3 style={styles.title}>🔍 System Inspector</h3>
          
          <div style={styles.section}>
            <strong>🌍 Environment:</strong>
            <pre>{JSON.stringify({
                host: window.location.hostname,
                merchantSlug: merchantSlug,
                path: location.pathname
            }, null, 2)}</pre>
          </div>

          <div style={styles.section}>
            <strong>👤 User State (Context):</strong>
            {/* 把這裡換成你真正的 User Object */}
            <pre>{JSON.stringify(user, null, 2)}</pre>
          </div>

          <div style={styles.section}>
            <strong>🔑 Local Storage (Tokens):</strong>
            <pre>{JSON.stringify(storageData.localStorage, null, 2)}</pre>
          </div>

          <div style={styles.section}>
            <strong>💾 Session Storage (Redirects):</strong>
            <pre>{JSON.stringify(storageData.sessionStorage, null, 2)}</pre>
          </div>
        </div>
      )}
    </div>
  );
};

// 簡單的 CSS Styles
const styles = {
  container: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 9999,
    fontFamily: 'monospace',
    fontSize: '12px',
  },
  button: {
    backgroundColor: '#ff4757',
    color: 'white',
    border: 'none',
    padding: '8px 15px',
    borderRadius: '5px',
    cursor: 'pointer',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    fontWeight: 'bold',
  },
  panel: {
    width: '400px',
    maxHeight: '80vh',
    overflowY: 'auto',
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    color: '#00d2d3',
    padding: '15px',
    borderRadius: '10px',
    marginTop: '10px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
  },
  title: {
    color: '#fff',
    borderBottom: '1px solid #555',
    paddingBottom: '5px',
    marginTop: 0,
  },
  section: {
    marginBottom: '15px',
    borderBottom: '1px solid #333',
    paddingBottom: '10px',
  }
};

export default SuperDebugger;